import type {FunctionalRole} from "@mytour/shared";
import type {ReactNode} from "react";
import {useIsAuthenticated} from "./authentication/authenticationQueries";
import {useContext} from "./contextQueries";

interface HasRoleProps {
  role: null | FunctionalRole | FunctionalRole[];
  children: ReactNode;
}

export function HasRole({role, children}: HasRoleProps) {
  const {context, isContextLoading} = useContext();
  const {isAuthenticated, isAuthenticatedLoading} = useIsAuthenticated();

  if (isContextLoading || isAuthenticatedLoading) {
    return null;
  }

  if (!isAuthenticated && role === null) {
    return children;
  }

  if (!context) {
    return null;
  }

  const allowedRoles = Array.isArray(role) ? role : [role];

  if (!allowedRoles.includes(context.role)) {
    return null;
  }

  return children;
}
